module.exports = __webpack_public_path__ + "static/media/bus.f88ef21b.png";